import React, { memo } from "react";
import { SoundButton } from "../SoundButton";
import { LiveButton } from "../LiveButton";
import { MoreButton } from "../MoreButton";
import { LikeButton } from "../LikeButton";
import { IGif } from "@/common/services/types";
import "./Sidebar.scss";

interface ISidebarProps {
  gif: IGif;
  liked: boolean;
  likesCount: number;
  gifSound: boolean;
  onMenu: (event: React.MouseEvent<HTMLButtonElement>, gif: IGif) => void;
  onLike: () => void;
  onSound: (sound: boolean) => void;
}

const Sidebar: React.FC<ISidebarProps> = memo((props) => {
  const {
    gif,
    likesCount,
    liked,
    gifSound,
    onLike,
    onSound,
    onMenu
  } = props;

  return (
    <ul className="sideBar">
      {gif.hasAudio && (
        <li className="sideBarItem">
          <SoundButton
            enabled={gifSound}
            onClick={() => onSound(!gifSound)}
          />
        </li>
      )}

      <li className="sideBarItem">
        <LikeButton
          liked={liked}
          count={likesCount}
          onClick={onLike}
        />
      </li>

      <li className="sideBarItem">
        <MoreButton onClick={(e) => onMenu(e, gif)} />
      </li>

      <li className="sideBarItem">
        <LiveButton />
      </li>
    </ul>
  );
});

export default Sidebar;
